import { render, staticRenderFns } from "./IconFlag.vue?vue&type=template&id=48d9d279&scoped=true&"
import script from "./IconFlag.vue?vue&type=script&lang=js&"
export * from "./IconFlag.vue?vue&type=script&lang=js&"
import style0 from "./IconFlag.vue?vue&type=style&index=0&id=48d9d279&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d9d279",
  null
  
)

export default component.exports